import React from "react";
import { uid } from "uid";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { additem } from "../redux/action";
import { toast } from "react-toastify";
const BookFrom = () => {
  const items = useSelector((state) => state.items);
  const [destinationform, setdestinationform] = useState("");
  const [destinationto, setdestinationto] = useState("");
  const [date, setdate] = useState("");
  const [guest, setguest] = useState("");
  const [classes, setclasses] = useState("");

  const dispath = useDispatch();

  const itemshandeler = (e) => {
    e.preventDefault();

    const additems = {
      id: uid(),
      destinationform,
      destinationto,
      date,
      guest,
      classes,
    };
    // error chack and data dispatch
    if (destinationform == "") {
      toast.error("Please select a destinationform");
    } else if (destinationto == "") {
      toast.error("Please select a destinationto");
    } else if (date == "") {
      toast.error("Please select a date");
    } else if (guest == "") {
      toast.error("Please select a guest");
    } else if (classes == "") {
      toast.error("Please select a classes");
    } else {
      if (items.length >= 3) {
        toast.error("user only added 3 flights");
      } else {
        dispath(additem(additems));
        toast.success("flights booked successfully");
      }
    }
    setdate("");
    setguest("");
    setdestinationform("");
    setdestinationto("");
  };

  return (
    <form className="first-hero lws-inputform" onSubmit={itemshandeler}>
      {/* From */}
      <div className="des-from">
        <p>Destination From</p>
        <div className="flex flex-row">
          <img src="img/icons/Frame.svg" alt="" />
          <select
            className="outline-none px-2 py-2 w-full"
            name="from"
            id="lws-from"
            required
            value={destinationform}
            onChange={(e) => setdestinationform(e.target.value)}
          >
            <option>Please Select</option>
            <option value="Dhaka">Dhaka</option>
            <option value="Sylhet">Sylhet</option>
            <option value="Saidpur">Saidpur</option>
            <option value="Cox's Bazar">Cox's Bazar</option>
          </select>
        </div>
      </div>
      {/* To */}
      <div className="des-from">
        <p>Destination To</p>
        <div className="flex flex-row">
          <img src="img/icons/Frame.svg" alt="" />
          <select
            className="outline-none px-2 py-2 w-full"
            name="to"
            id="lws-to"
            required
            value={destinationto}
            onChange={(e) => setdestinationto(e.target.value)}
          >
            <option>Please Select</option>
            <option value="Dhaka">Dhaka</option>
            <option value="Sylhet">Sylhet</option>
            <option value="Saidpur">Saidpur</option>
            <option value="Cox's Bazar">Cox's Bazar</option>
          </select>
        </div>
      </div>
      {/* Date */}
      <div className="des-from">
        <p>Journey Date</p>
        <input
          value={date}
          type="date"
          className="outline-none px-2 py-2 w-full date"
          name="date"
          id="lws-date"
          required
          onChange={(e) => setdate(e.target.value)}
        />
      </div>
      {/* Guests */}
      <div className="des-from">
        <p>Guests</p>
        <div className="flex flex-row">
          <img src="img/icons/Vector (1).svg" alt="" />
          <select
            className="outline-none px-2 py-2 w-full"
            name="guests"
            id="lws-guests"
            required
            value={guest}
            onChange={(e) => setguest(e.target.value)}
          >
            <option>Please Select</option>
            <option value={1}>1 Person</option>
            <option value={2}>2 Persons</option>
            <option value={3}>3 Persons</option>
            <option value={4}>4 Persons</option>
          </select>
        </div>
      </div>
      {/* Class */}
      <div className="des-from !border-r-0">
        <p>Class</p>
        <div className="flex flex-row">
          <img src="img/icons/Vector (3).svg" alt="" />
          <select
            className="outline-none px-2 py-2 w-full"
            name="ticketClass"
            id="lws-ticketClass"
            required
            value={classes}
            onChange={(e) => setclasses(e.target.value)}
          >
            <option value="" hidden="">
              Please Select
            </option>
            <option value="Business">Business</option>
            <option value="Economy">Economy</option>
          </select>
        </div>
      </div>
      <button className="addCity" type="submit" id="lws-addCity">
        <svg
          width="15px"
          height="15px"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 4.5v15m7.5-7.5h-15"
          />
        </svg>
        <span className="text-sm">Book</span>
      </button>
    </form>
  );
};

export default BookFrom;
